import {web3} from 'decentralized/web3.js';

const blocksPerDay = 6600;
const hop = 198000;

export const getBlockMonths = async () => {
    let currentBlockNumber = await web3.eth.getBlockNumber();
    let block = null;
    let date = new Date();
    let day = date.getDate();
    let month = date.getMonth();
    currentBlockNumber -= day * 6000;

    let currentMonth = month;
    let months = {};
    for (let i=0; i < 12; i++) {
        block = await web3.eth.getBlock(currentBlockNumber);
        date = new Date(block.timestamp * 1000);
        let d = new Date(date.getFullYear(), date.getMonth(), 0).getDate();;
        months[currentMonth--] = currentBlockNumber;
        currentBlockNumber -= blocksPerDay * d;
    }
    return months;
};
